import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState, useCallback } from "react";
import TaskCard from "./TaskCard";
import { setKeyValue } from "../../../../store/tasks/slice";
import { useDispatch } from "react-redux";

const TaskColumn = ({
  column,
  dragInfo,
  onDragStart,
  onDrop,
  setSelectedColumn,
}) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const dispatch = useDispatch();

  const handleColumnDragOver = useCallback((e) => {
    e.preventDefault();
    setIsDragOver(true);
  }, []);

  const handleColumnDragLeave = useCallback(() => setIsDragOver(false), []);

  const handleColumnDrop = useCallback(
    (e) => {
      e.preventDefault();
      setIsDragOver(false);
      onDrop(column.id, null);
    },
    [onDrop, column.id],
  );

  const handleAddTask = useCallback(() => {
    dispatch(
      setKeyValue({ value: { column_id: column?.id }, key: "selectedTask" }),
    );
  }, [column?.id]);

  return (
    <div
      className={`tasks-column${isDragOver ? " tasks-column--drag-over" : ""}`}
      onDragOver={handleColumnDragOver}
      onDragLeave={handleColumnDragLeave}
      onDrop={handleColumnDrop}
    >
      <div className="tasks-column__header">
        <span
          className="tasks-column__title cursor-pointer"
          onClick={() => setSelectedColumn(column)}
        >
          {column.name}
        </span>
        <span className="tasks-column__count">{column.tasks.length}</span>
      </div>

      <div className="tasks-column__footer">
        <Button
          type="dashed"
          icon={<PlusOutlined />}
          size="small"
          className="tasks-column__add-btn"
          onClick={handleAddTask}
          block
        >
          Add Task
        </Button>
      </div>

      <div className="tasks-column__body">
        {column.tasks.map((task, index) => (
          <TaskCard
            key={task.id}
            task={task}
            index={index}
            columnId={column.id}
            isDragging={dragInfo?.taskId === task.id}
            onDragStart={onDragStart}
            onDrop={onDrop}
          />
        ))}
      </div>
    </div>
  );
};

export default TaskColumn;
